import { BackofficePromoPeriods } from '@diamond/shared/types';

/**
 * Determine promo period value based on date range
 * @param fromDate Start date string in DD/MM/YYYY format
 * @param toDate End date string in DD/MM/YYYY format
 * @returns BackofficePromoPeriods value based on date range
 */
export const getPromoPeriodValue = (
  fromDate?: string,
  toDate?: string
): BackofficePromoPeriods => {
  if (!fromDate || !toDate) return '1';

  const today = new Date();

  const from = new Date(fromDate.split('/').reverse().join('-'));

  const diffDays = Math.round(
    (today.getTime() - from.getTime()) / (1000 * 60 * 60 * 24)
  );

  if (diffDays <= 32) return '1'; // ~1 month
  if (diffDays <= 95) return '3'; // ~3 months
  if (diffDays <= 185) return '6'; // ~6 months

  return 'custom_date';
};

/**
 * Format date for API consumption
 * @param dateStr Date string in DD/MM/YYYY format
 * @returns Formatted date string in YYYY-MM-DD format
 */
export const formatDateForApi = (dateStr: string): string => {
  if (!dateStr) return '';
  const [day, month, year] = dateStr.split('/');
  return `${year.length === 2 ? '20' + year : year}-${month}-${day}`;
};
